<template>
    <Transition name="modal-fade">
        <div v-if="isdisplay" class="cf-overlay" @click.self="close">
            <Transition name="modal-slide">
                <div v-if="isdisplay" class="cf-dialog cf-dialog--xl">

                <div class="cf-modal-head cf-dialog-head">
                    <div class="cf-modal-head__main">
                        <span class="cf-modal-head__icon"><i class="ri-check-double-line"></i></span>
                        <div>
                            <h4 class="cf-dialog-title">Validation</h4>
                            <p class="cf-modal-head__sub">Valider le transfert</p>
                        </div>
                    </div>
                    <button @click="close" type="button" class="cf-dialog-close" aria-label="Fermer"><i class="ri-close-line"></i></button>
                </div>
                <div class="cf-dialog-body">

                    <div class="box-body">
                        <div class="border-b-0 border-gray-200 dark:border-white/10">
                            <nav class="flex flex-wrap text-sm font-medium text-center text-gray-500 border-b border-gray-200 dark:border-gray-700 dark:text-gray-400" aria-label="Tabs">
                                <button type="button" class="hs-tab-active:bg-white hs-tab-active:border-b-transparent
                                                hs-tab-active:text-primary dark:hs-tab-active:bg-transparent dark:hs-tab-active:border-b-white/10 dark:hs-tab-active:text-primary -mb-px py-2 px-3
                                                 inline-flex items-center gap-2 bg-gray-50 text-sm font-medium text-center border text-defaulttextcolor rounded-t-sm hover:text-primary
                                                 dark:bg-black/20 dark:border-white/10 dark:text-[#8c9097] dark:text-white/50 dark:hover:text-gray-300 active"
                                        id="hs-tab-js-behavior-item-1" data-hs-tab="#hs-tab-js-behavior-1" aria-controls="hs-tab-js-behavior-1">
                                    Information de base
                                </button>



                            </nav>
                        </div>

                        <div class="">
                            <div id="hs-tab-js-behavior-1" role="tabpanel" aria-labelledby="hs-tab-js-behavior-item-1" class="">


                                <div v-if="messagesucces!==''" class="mt-4 mb-4 alert alert-success !border-success/10 flex items-center" role="alert">

                                    <div v-html="messagesucces">

                                    </div>
                                </div>

                                <div v-if="messageerror!==''" class="mt-4 mb-4 alert alert-danger !border-danger/10 flex items-center" role="alert">

                                    <div v-html="messageerror">

                                    </div>
                                </div>


                                <div class="alert alert-info text-center mt-3">
                                    <p style="color: black;font-size: 15px;">N° document : {{Items.numdoc}} / Date : {{Items.datedoc}} </p>
                                </div>



                                <template v-if="Items.etatdelatransaction===0">

                                        <div class="alert alert-danger mt-3" role="alert">
                                            Transaction en cours de validation
                                        </div>

                                </template>
                                <template v-if="Items.etatdelatransaction===1">

                                        <div class="alert alert-success mt-3" role="alert">
                                            Transaction validée
                                        </div>

                                </template>
                                <template v-if="Items.etatdelatransaction===2">

                                    <div class="alert alert-danger mt-3" role="alert">
                                        Transaction annulée
                                    </div>

                                </template>


                                <div class="ti-custom-validation mt-5" >


                                    <div class="grid lg:grid-cols-2 gap-6">

                                        <div class="space-y-2 mt-5">
                                            <label class="text-capitalize ti-form-label dark:text-defaulttextcolor/70 mb-0">{{titlecp}} :</label>
                                            <input  :value="Items.caissecrediteur" disabled type="text" class="form-control" >

                                        </div>
                                        <div class="space-y-2 mt-5">
                                            <label class="text-capitalize ti-form-label dark:text-defaulttextcolor/70 mb-0">{{titleca}} :</label>
                                           <input  :value="Items.caissedebiteur" disabled type="text" class="form-control" >


                                        </div>




                                    </div>


                                    <div class="space-y-2 mt-5">
                                        <label  class="text-capitalize ti-form-label
                                            dark:text-defaulttextcolor/70 mb-0">MOTIF / RAISON</label>

                                        <textarea :value="Items.motif" disabled class="form-control" cols="5" rows="2"></textarea>

                                    </div>




                                    <div class="space-y-2 mt-5">
                                        <label  class="text-capitalize ti-form-label
                                            dark:text-defaulttextcolor/70 mb-0">Montant</label>
                                        <input  :value="Items.montant" disabled type="number" class="form-control" >

                                    </div>




                                </div>
                            </div>



                        </div>
                    </div>




                </div>
                <div class="cf-dialog-foot">
                    <button @click="close" type="button" class="ti-btn ti-btn-secondary-full">Fermer</button>
                    <button class="ti-btn ti-btn-primary-full" @click="saveItems">
                        <i class="ri-check-line align-middle"></i> Enregistrer
                    </button>
                </div>

                </div>
            </Transition>
        </div>
    </Transition>

    <validationouinon ref="validationouinon" @aftervalidation="aftervalidation"></validationouinon>
</template>

<script>

   // import allfunction from "@/allfunction";
    import {currencyFormatDE} from "@/allfunction";

    import validationouinon from "@/components/views/pages/caisse/validationtransaction/validationouinon";


    export default {
        /* eslint-disable */
        name: "modalform",
        watch: {


        },

        computed:{



        },
        components: {
            validationouinon

        },

        data() {
            return {
                isdisplay:false,
                messageerror:"",
                messagesucces:"",
                classcaisse:"",
                checkvalue:false,
                titlemodal:"",
                alldata:{},
                typedoc:"",
                titleca:"",
                titlecp:"",
                vtypc:"",
                typereglement:'',
                authoriationplslignedepense:0,
                typeaction:"add",
                Items: {},

                name:'',
                typoperation:'DEBIT',
                banque:null,
                pcharge:null,
                numbordereau:"",
                deposantname:"",
                numcheque:"",
            };
        },
        methods: {

            formatMoney(value){
                return currencyFormatDE(value)

            },


            aftervalidation(){

                this.$emit('closed');
                this.isdisplay=false;

            },

            close(){

                this.isdisplay=false;

            },

            show(titlemodal,Items,titleca,titlecp,typedoc){

                this.titlemodal=titlemodal
                this.Items=Items
                this.titleca=titleca
                this.titlecp=titlecp
                this.typedoc=typedoc



                this.isdisplay=true;

            },

            currencyFormatDE(p1){
                var number=Number(p1)
                return currencyFormatDE(number)
            },


            async  saveItems(){



                let value={
                    'cf':this.$store.state.caisseinfo,
                    'item':this.Items,
                    'document':this.typedoc,
                }



                let titlemodal="";

                titlemodal=`

                      <h4>
                               Voulez-vous vraiment valider la transaction ?

                      </h4>

                      `;



                this.$refs.validationouinon.show(titlemodal,value,this.typedoc);


            },



        },
        mounted() {

            // this.loaddata();
        }




    }
</script>

<style scoped>
/* Charte cf-/ds- : tokens uniquement (light-only) */
.cf-overlay { position:fixed; inset:0; z-index:1000; display:flex; align-items:center; justify-content:center; padding:1rem; background:rgb(15 23 42 / 0.45); }
.cf-dialog { width:100%; background:#fff; border-radius:var(--cf-radius); box-shadow:var(--cf-shadow-md); display:flex; flex-direction:column; max-height:90vh; overflow:hidden; }
.cf-dialog--xl { max-width:1050px; }
.cf-dialog-head { display:flex; align-items:center; justify-content:space-between; padding:1rem 1.25rem; border-bottom:1px solid var(--cf-border); flex-shrink:0; }
.cf-dialog-title { margin:0; font-size:0.95rem; font-weight:700; color:var(--cf-ink-strong); }
.cf-dialog-close { height:2rem; width:2rem; flex-shrink:0; display:inline-flex; align-items:center; justify-content:center; border-radius:var(--cf-radius-sm); border:none; background:var(--cf-surface-alt); color:var(--cf-muted); cursor:pointer; transition:all .15s; }
.cf-dialog-close:hover { background:#fee2e2; color:rgb(var(--danger)); }
.cf-dialog-body { padding:1.1rem 1.25rem; overflow-y:auto; flex:1; }
.cf-dialog-foot { display:flex; align-items:center; justify-content:flex-end; gap:0.6rem; padding:0.9rem 1.25rem; border-top:1px solid var(--cf-border); background:var(--cf-surface); flex-shrink:0; }

.modal-fade-enter-active, .modal-fade-leave-active { transition:opacity 0.25s ease; }
.modal-fade-enter-from, .modal-fade-leave-to { opacity:0; }
.modal-slide-enter-active, .modal-slide-leave-active { transition:all 0.25s ease; }
.modal-slide-enter-from, .modal-slide-leave-to { opacity:0; transform:translateY(-16px); }

@media (max-width:768px) { .cf-dialog--xl { max-width:100%; } }
</style>